import { mapRecordToArray } from '@deity-io/di-data-basics';
import { EndpointContext } from 'contexts/EndpointContext';
import RequestExplorerProvider from 'contexts/RequestExplorer/RequestExplorerProvider';
import { UIContext } from 'contexts/UIContext';
import { CACHE_FIRST, ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import type { FC } from 'react';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetPackageVersionQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';
import { buildConfigurationStore } from 'utils/build-configuration-store';
import RequestExplorer from './RequestExplorer';

interface RequestExplorerProps {
  locked?: boolean;
}
/**
 * Provides the context, now bound to the Endpoint (context)
 */
const RequestExplorerWrapper: FC<RequestExplorerProps> = ({ locked }) => {
  const ctx = useContext(EndpointContext);
  const ctxUI = useContext(UIContext);

  /**
   * Todo, get this info from the endpoint
   */
  const { pathname } = useLocation();
  const urlParams = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);
  const params = ctx?.state.variables
    ? mapRecordToArray(ctx?.state.variables, (value, key) => [key, value] as [string, string])
    : [];
  const headers = ctx?.state.headers
    ? mapRecordToArray(ctx?.state.headers, (value, key) => [key, value] as [string, string])
    : [];
  let url = `${ctx?.state.protocol}://${ctx?.state.host}${ctx?.state.path}`;
  if (params.length) {
    url += '?';
    url += params.map(param => `${param[0]}=${param[1]}`).join('&');
  }
  const { data, loading } = useGetPackageVersionQuery({
    variables: {
      uuid: urlParams?.versionUuid
    },
    skip: !urlParams?.versionUuid,
    ...CACHE_FIRST
  });
  if (!data) {
    return null;
  }

  const availableVariableValues = buildConfigurationStore(ctxUI?.state.currentEnvironment, data);

  return (
    <RequestExplorerProvider
      method={ctx?.state.method}
      url={url}
      headers={headers}
      structureUuid={typeof ctx?.state.responseStructure === 'string' ? ctx?.state.responseStructure : undefined}
      packageVersionUuid={ctx?.state.packageVersionUuid}
      authentication={ctx?.state.authentication}
    >
      <RequestExplorer availableVariableValues={availableVariableValues} />
    </RequestExplorerProvider>
  );
};

export default RequestExplorerWrapper;
